export enum OrderBy {
  ASC = 'asc',
  DESC = 'desc'
}
